var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoLocationArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.192 8.615A1.197 1.197 0 011 7.654a1.243 1.243 0 01.73-1.385L15.27.731c.46-.193 1-.077 1.345.269.347.346.462.885.27 1.346l-5.539 13.539a1.243 1.243 0 01-2.384-.5v-6.77h-6.77zm8.039-1.23v8l5.538-13.539L2.192 7.385h8.039z",
    fill: "currentColor"
  })));
}
export default SvgGeoLocationArrowIcon;